/*
 * @Author: 赵泽文
 * @Date: 2022-05-17 15:30:35
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-06-03 00:12:46
 * @Description: 配方管理model
 */
import type { IFormulaModel, IFormulaStore } from '@monorepo/types/process/formula/formula.types';

const initState: IFormulaStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    sort_order: 'CREATED_DESC',
  },
  formulaWithoutMaterial: [],
};

const formula: IFormulaModel = {
  namespace: 'formulaStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      return {
        ...state,
        tableList: payload.data,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default formula;
